import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';

export enum ECellActionType {
  CELL_COORDINATE,
  CELL_NAME
}

@Component({
  selector: 'biz-excel-connector-item-detail',
  templateUrl: './connect-excel-item-detail.component.html',
  styleUrls: ['./connect-excel-item-detail.component.scss']
})
export class ExcelConnectorItemDetailComponent implements OnInit {
  @ViewChild('excelUploaderInput', { static: false})
  private excelUploaderInput: ElementRef;
  @ViewChild('formFile', { static: false})
  private formFile: ElementRef;
  private _selectedVersionDetail: IExcelVersionConnector;
  private _selectedConnector: IExcelConnector;

  @Input('selectedConnector')
  set selectedConnector(value: IExcelConnector) {
    this.fileName = '';
    this._selectedVersionDetail = null;
    if (value && value.versionDetail) {
      this.fileName = value.versionDetail.excelFile.name;
      this._selectedVersionDetail = value.versionDetail;
    }
    this._selectedConnector = value;
  }

  get selectedConnector(): IExcelConnector {
    if(this._selectedConnector && this._selectedConnector.versionDetail) {
      this._selectedConnector.versionDetail.excelFile.name = this.fileName;
    }

    return this._selectedConnector;
  }

  get selectedVersionDetail(): IExcelVersionConnector {
    return this._selectedVersionDetail;
  }
  @Input() isLoading: boolean;
  @Input() isUploading: boolean;
  @Input() selectedConnectorChild: IExcelConnectorChildren;


  @Input('resetInputFile')
  set resetInputFile(value: boolean) {
    if (value && this.excelUploaderInput) {
      this.fileName = '';
      this.excelUploaderInput.nativeElement.value = '';
      this.formFile.nativeElement.reset();
    }
  }
  @Output() uploadFile = new EventEmitter<any>();
  @Output() versionChanged = new EventEmitter<IExcelConnectorChildren>();
  @Output() save = new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  public selectedAction: any;
  public eCellActionType = ECellActionType;
  public fileName: string;

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resetInputFile && changes.resetInputFile.currentValue === true) {
      this.resetInputFiles();
    }
  }

  onDownload() {
    if(this.selectedVersionDetail) {
      this.download.emit(this.selectedVersionDetail.excelFile);
    }
  }

  onUploadFile($event) {
    if ($event.target.files.length) {
      this.fileName = $event.target.files[0].name;
      this.uploadFile.emit($event.target.files[0]);
    }
  }

  onVersionChanged(children: IExcelConnectorChildren) {
    this.resetInputFile = false;
    this.versionChanged.emit(children);
  }

  onSave() {
    this.save.emit();
  }

  onSelectAction(action: any) {
    this.selectedAction = !this.selectedAction || this.selectedAction.actionname !== action.actionname ? action : undefined;
  }

  onCancel() {
    this.cancel.emit();
  }

  private resetInputFiles() {
    if(this.excelUploaderInput){
      this.excelUploaderInput.nativeElement.value = '';
      this.formFile.nativeElement.reset();
    }
  }

  distanceBetweenColumns(columnRange: string): number {
    const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
      'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const excelColumns: Array<string> = columnRange.split(':');
    const deconstructionFirstColumn = this._stringToChartArray(excelColumns[0]);
    const deconstructionSecondColumn = this._stringToChartArray(excelColumns[1]);
    const bottomRangeColumn = deconstructionFirstColumn.filter((value: string) => parseInt(value, 10).toString() === 'NaN');
    const topRangeColumn = deconstructionSecondColumn.filter((value: string) => parseInt(value, 10).toString() === 'NaN');
    return ((alphabet.indexOf(topRangeColumn[0].toUpperCase()) + 1) - alphabet.indexOf(bottomRangeColumn[0].toUpperCase()));
  }

  getColumnsDefinition(columnsDef: { [key: string]: string }) {
    return Object.keys(columnsDef);
  }

  private _stringToChartArray(localString: string): Array<string> {
    const result: Array<string> = [];
    for (let i = 0; i < localString.length; i++) {
      result[i] = localString[i];
    }
    return result;
  }
}
